import React, { useState, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { Button } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core";
import moment from "moment";

import AddModal from "./AddModal";
import RemoveModal from "./RemoveModal";

import { useAuth } from "../../../../../contexts/AuthContext";
import {
  addCalendarEvent,
  removeCalendarEvent,
} from "../../../../../redux/firebaseCalls";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    // height: "82vh",
    // overflowY: "scroll",
    // '&::-webkit-scrollbar': {
    //   display: "none"
    // },
    padding: theme.spacing(2),
  },
  modalOpenButton: {
    width: "100%",
    marginTop: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontWeight: 700,
  },
  modalOpenRemoveButton: {
    width: "100%",
    marginTop: theme.spacing(2),
    color: "#fff",
    fontWeight: 700,
  },
}));

export default function CalendarTab() {
  const classes = useStyles();
  const calendarRef = useRef();

  // AddModal State Management
  const [openAdd, setOpenAdd] = useState(false);
  const titleRef = useRef();
  const [color, setColor] = useState("Blue");
  const [dateStart, setDateStart] = useState(new Date());
  const [dateEnd, setDateEnd] = useState(new Date());

  // RemoveModal State Management
  const [openRemove, setOpenRemove] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const [helperText, setHelperText] = useState("Ordered by nearest date from today");

  const [error, setError] = useState("");
  const { currentUser } = useAuth();
  const dispatch = useDispatch();
  const eventsRedux = useSelector((state) => state.calendar.calendarList);
  const loadingRedux = useSelector((state) => state.calendar.pending);
  // const errorRedux = useSelector((state) => state.calendar.error);

  const handleOpenAddModal = () => {
    setOpenAdd(true);
    setDateStart(new Date());
    setDateEnd(new Date());
  };

  const handleOpenRemoveModal = () => {
    setOpenRemove(true);
  };

  const handleCalendarDateClick = (info) => {
    //alert(info.dateStr + " " + info.view.type);
    // alert(new Date() + "\n" + new Date(moment(info.dateStr).toString()));
    // Need to change from ISO format to normal date format check react-date-picker
    // console.log(moment(info.dateStr).toString());
    // console.log(info.dateStr);
    setDateStart(new Date(moment(info.dateStr).toString()));
    setDateEnd(new Date(moment(info.dateStr).toString()));
    setOpenAdd(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let calendarApi = calendarRef.current.getApi();
    calendarApi.addEvent(
      {
        title: titleRef.current.value,
        start: moment(dateStart).toDate(),
        end: moment(dateEnd).toDate(),
        color: color.toLowerCase(),
      },
      true
    ); // temporary = true
  };

  const handleAddEvent = async (data) => {
    //console.log(data)
    setError("");
    const docData = {
      title: data.event.title,
      start: data.event.start,
      end: data.event.end,
      color: data.event.backgroundColor,
    };
    try {
      await addCalendarEvent(docData, currentUser.uid, dispatch);
      setOpenAdd(false);
    } catch (error) {
      setError("Something went wrong");
    }
  };

  const handleSubmitRemove = (event) => {
    event.preventDefault();
    if (radioValue){
      let calendarApi = calendarRef.current.getApi();
      const eventId = calendarApi.getEventById(radioValue);
      eventId.remove();
      setHelperText("Ordered by nearest date from today");
    } else {
      setHelperText("Please select an option");
    }
  };

  const handleRemoveEvent = async () => {
    try {
      await removeCalendarEvent(radioValue, currentUser.uid, dispatch);
      setRadioValue("");
      setOpenRemove(false);
    } catch (err) {
      setError("Something went wrong");
      setOpenRemove(false);
    }
  };

  return (
    <div className={classes.wrapper}>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        dateClick={handleCalendarDateClick}
        headerToolbar={{
          start: "today prev,next",
          center: "title",
          end: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        }}
        ref={calendarRef}
        eventAdd={handleAddEvent}
        eventRemove={handleRemoveEvent}
        events={eventsRedux}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenAddModal}
        className={classes.modalOpenButton}
      >
        Add Event
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleOpenRemoveModal}
        className={classes.modalOpenRemoveButton}
      >
        Remove Event
      </Button>
      {error && (
        <Alert severity="error" style={{ marginTop: 15 }}>
          {error}
        </Alert>
      )}
      <AddModal
        open={openAdd}
        setOpen={setOpenAdd}
        handleSubmit={handleSubmit}
        titleRef={titleRef}
        color={color}
        setColor={setColor}
        dateStart={dateStart}
        setDateStart={setDateStart}
        dateEnd={dateEnd}
        setDateEnd={setDateEnd}
        loading={loadingRedux}
      />
      <RemoveModal
        open={openRemove}
        setOpen={setOpenRemove}
        handleSubmit={handleSubmitRemove}
        radioValue={radioValue}
        setRadioValue={setRadioValue}
        helperText={helperText}
        loading={loadingRedux}
      />
    </div>
  );
}
